const cards = [
  {
    title: '狂飙',
    desc: '张颂文、张译主演反黑刑侦剧，全39集完整版在线观看，豆瓣8.5分现象级爆款',
    tag: '国产剧',
    rating: '8.5',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20Chinese%20crime%20drama%20poster%20style%2C%20two%20men%20in%20formal%20suits%20facing%20each%20other%20in%20tense%20standoff%2C%20dark%20alley%20background%20with%20warm%20streetlight%2C%20cinematic%20noir%20lighting%2C%20intense%20atmosphere%2C%20professional%20movie%20poster%20aesthetic%2C%20no%20text&width=400&height=560&seq=card-luobo-01&orientation=portrait'
  },
  {
    title: '繁花',
    desc: '王家卫首部电视剧，胡歌马伊琍主演上海传奇，全30集全集高清在线',
    tag: '国产剧',
    rating: '8.7',
    image: 'https://readdy.ai/api/search-image?query=Elegant%201990s%20Shanghai%20night%20scene%20with%20neon%20lights%20reflecting%20on%20wet%20street%2C%20a%20man%20in%20vintage%20suit%20walking%20through%20bustling%20city%2C%20golden%20warm%20tones%2C%20nostalgic%20cinematic%20atmosphere%2C%20film%20noir%20aesthetic%2C%20no%20text&width=400&height=560&seq=card-luobo-02&orientation=portrait'
  },
  {
    title: '黑暗荣耀',
    desc: '宋慧乔复仇大戏，全16集完整版在线观看，Netflix年度韩剧口碑之作',
    tag: '韩剧',
    rating: '8.9',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20style%2C%20elegant%20woman%20in%20dark%20sophisticated%20outfit%20standing%20in%20minimal%20room%20with%20dramatic%20shadow%2C%20cold%20blue%20and%20warm%20amber%20contrast%20lighting%2C%20intense%20gaze%2C%20cinematic%20composition%2C%20no%20text&width=400&height=560&seq=card-luobo-03&orientation=portrait'
  },
  {
    title: '漫长的季节',
    desc: '豆瓣9.4分国产悬疑神作，范伟秦昊主演全12集完整版，年度必看',
    tag: '国产剧',
    rating: '9.4',
    image: 'https://readdy.ai/api/search-image?query=Northeast%20China%20autumn%20industrial%20town%20scene%2C%20golden%20fallen%20leaves%20on%20old%20railway%20tracks%2C%20warm%20nostalgic%20sunset%20light%2C%20two%20middle-aged%20men%20in%20thick%20jackets%20standing%20by%20train%2C%20mysterious%20atmospheric%20cinematography%2C%20no%20text&width=400&height=560&seq=card-luobo-04&orientation=portrait'
  },
  {
    title: '琅琊榜',
    desc: '胡歌巅峰之作，全54集高清修复版全集在线，国产古装权谋剧天花板',
    tag: '国产剧',
    rating: '9.4',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20classical%20elegant%20man%20in%20white%20robes%20standing%20on%20misty%20mountain%20peak%20with%20traditional%20architecture%20in%20distance%2C%20soft%20ethereal%20lighting%2C%20ink%20wash%20painting%20aesthetic%2C%20dreamy%20atmosphere%2C%20no%20text&width=400&height=560&seq=card-luobo-05&orientation=portrait'
  },
  {
    title: '眼泪女王',
    desc: '金秀贤金智媛主演浪漫爱情韩剧，全16集完整版在线观看，年度热门',
    tag: '韩剧',
    rating: '8.3',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20poster%20style%2C%20elegant%20couple%20in%20formal%20evening%20attire%20standing%20close%20under%20sparkling%20chandelier%2C%20soft%20golden%20bokeh%20background%2C%20warm%20romantic%20atmosphere%2C%20luxurious%20ballroom%20setting%2C%20cinematic%20quality%2C%20no%20text&width=400&height=560&seq=card-luobo-06&orientation=portrait'
  },
  {
    title: '长安十二时辰',
    desc: '雷佳音易烊千玺主演古装悬疑剧，全48集全集在线观看，制作精良',
    tag: '国产剧',
    rating: '8.2',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20city%20at%20night%20with%20lanterns%20and%20bustling%20market%2C%20two%20men%20in%20traditional%20armor%20and%20robes%20riding%20horses%20through%20crowded%20street%2C%20dramatic%20torch%20lighting%2C%20epic%20cinematic%20scale%2C%20no%20text&width=400&height=560&seq=card-luobo-07&orientation=portrait'
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">
              热播推荐
            </h2>
            <p className="text-foreground-400 text-sm max-w-[500px] mx-auto">
              精选最热门电视剧全集与连续剧完整版，高清在线免费观看
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {cards.map((card, i) => (
              <div
                key={i}
                className={`group bg-background-100 rounded-xl overflow-hidden border border-background-300/30 hover:border-primary-500/40 cursor-pointer transition-all duration-300 ${
                  i === 0 ? 'sm:col-span-2 sm:row-span-2' : ''
                }`}
              >
                <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[4/5]' : 'aspect-[3/4]'}`}>
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading={i > 3 ? 'lazy' : undefined}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
                  <div className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-md bg-primary-500 text-foreground-50 text-xs font-medium whitespace-nowrap">
                    {card.tag}
                  </div>
                  <div className="absolute top-2.5 right-2.5 px-2 py-0.5 rounded-md bg-background-50/80 text-accent-400 text-xs font-medium whitespace-nowrap">
                    <i className="ri-star-fill text-[10px] mr-0.5"></i>
                    {card.rating}
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="font-heading text-foreground-50 text-sm md:text-base mb-1.5">
                    {card.title}
                  </h3>
                  <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                    {card.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}